<app-formulario #ctrl URL="grupo/matricula" titulo="Alumno / Control Escolar" [dato]="dato"></app-formulario>
<app-sistema-menu></app-sistema-menu>

<div class="contenedor columns " style="height:100%; ">
    <div class="column is-hidden-mobile menu-izquierda is-2">
        <app-sistema-menu-aside></app-sistema-menu-aside>
    </div>
    <div class="column" style="padding:0px;">
        <div style="background: #FFF; border-radius: 1em; ">
            <!-- formulario -->
            <form name="form" novalidate [formGroup]="dato" (ngSubmit)="ctrl.enviar(false)">
                <section class="hero is-primary">
                    <div class="hero-body">
                        <nav class="level">
                            <!-- Left side -->
                            <div class="level-left">
                                <div class="level-item">
                                    <p class="title">
                                        <span *ngIf="!ctrl.cargando" class="icon is-medium">
                                            <i class="icon-candidate"></i>
                                        </span>
                                        <span *ngIf="ctrl.cargando" class="icon is-medium">
                                            <i class="fa fa-refresh fa-spin"></i>
                                        </span>
                                        <span class="icon is-medium">
                                            <i class="fa fa-file"></i>
                                        </span> Matricular
                                    </p>
                                </div>

                            </div>

                            <!-- Right side -->
                            <div class="level-right">
                                <a class="navbar-item tooltip" (click)="ctrl.regresar()">
                                    <span class="icon fa-2x">
                                        <i class="fa fa-arrow-left"> </i>
                                    </span>
                                    <span class="tooltiptext">Regresar</span>
                                </a>

                                <button class="navbar-item  is-success tooltip" type="submit"
                                    [ngClass]="{'is-loading': ctrl.cargando}"
                                    [disabled]="ctrl.dato.invalid || ctrl.cargando">
                                    <span class="icon fa-2x has-text-success">
                                        <i class="fa fa-save"> </i>
                                    </span>
                                    <span class="tooltiptext">Guardar</span>
                                </button>
                            </div>
                        </nav>

                    </div>
                </section>
                <div id="banner" align="center" *ngIf="ctrl.cargando || cargarDatosCatalogo">
                    <div class="bloquear-azul">

                    </div>
                    <span class="tag is-primary is-large "
                        style="position: absolute; top: 45%; font-size: 2em; z-index: 999999999;  left: 45%;">
                        <span class="icon">
                            <i class="fa fa-refresh fa-spin"></i>
                        </span> &nbsp;
                        <span>Cargando...</span>
                    </span>
                </div>
                <section class="section" style="padding: 1rem; height: 87.2vh;">

                    <!-- cargar los catalogos que se requieran parametro 1 modelo donde se guarda el catalogo, parametro 2 ruta de la api -->
                    <a id="catalogos"
                        (click)="ctrl.cargarCatalogo('periodos_escolares', 'periodo-escolar-catalogo');"></a>
                    <a id="message" (click)="ctrl.mostrar_mensaje(titulo, mensaje, clase);"></a>
                    <div class="columns">
                        <div class="column is-6">
                            <label class="label">Perído escolar:</label>
                            <div class="control has-icons-left has-icons-right">
                                <div class="select">
                                    <select class="select" name="periodos_escolares_id"
                                        formControlName="periodos_escolares_id" (change)="ctrl.catalogoDependiente('grupos-calificaciones','grupos' ,ctrl.dato.get('periodos_escolares_id').value)">
                                        <option value="0">Seleccione</option>
                                        <option *ngFor="let item of ctrl.periodos_escolares;" value="{{item.id}}">
                                            {{item.text}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
<!-- ya casi funciona -->
                        <div class="column is-6">
                            <label class="label">Grupos:</label>
                            <div class="control has-icons-left has-icons-right">
                                <div class="select">
                                    <select class="select" name="grupos_id"
                                        formControlName="grupos_id" (change)="detalleGrupo(ctrl.periodo_escolar,ctrl.dato.get('grupos_id').value)"  [attr.disabled]="(ctrl.grupos)? null : true">
                                        <option value="0">Seleccione</option>
                                        <option *ngFor="let item of ctrl.grupos;" value="{{item.id}}" >
                                            {{item.text}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="column is-6">
                            <label class="label">Período escolar: </label>
                            <div class="control has-icons-left has-icons-right">

                                <span class="icon is-small is-left">
                                    <i class="icon-worldwide fa-spin" *ngIf="ctrl.cargando_periodo"></i>
                                </span>

                                <ng-select2
                                    [disabled]="ctrl.periodos_escolares ? ctrl.periodos_escolares.length == 0 ? true : false : true"
                                    [options]="ctrl.optionSelect" ([ngModel])="periodo_escolar"
                                    (valueChanged)="ctrl.grupos = []; this.dato.controls.grupos = this.fb.array([]); ctrl.seleccionarValorSelect2($event, 'periodo_escolar', 'grupos-calificaciones', 'grupos');"
                                    [data]="ctrl.periodos_escolares"></ng-select2>
                            </div>
                        </div> -->
                        <!-- <div class="column is-6">
                            <label class="label">Grupo:</label>
                            <div class="control has-icons-left has-icons-right">
                                <ng-select2 [disabled]="ctrl.grupos ? ctrl.grupos.length == 0 ? true : false : true" [options]="ctrl.optionSelect" ([ngModel])="grupo" (valueChanged)="detalleGrupo($event, ctrl.periodo_escolar);" [data]="ctrl.grupos"></ng-select2>
                            </div>
                        </div> -->

                    </div>
                    <div class="box" *ngIf="carrera_plan">
                        <article class="media">
                            <div class="media-content">
                                <nav class="level">
                                    <div lass="level-left">
                                        <div class="level-item">
                                            <p align="center">

                                                <strong>Carrera Plan:</strong> {{carrera_plan.planes_estudios.nombre}}
                                                <strong> Carrera:</strong> {{carrera_plan.carreras.nombre}}
                                                <br>
                                                <strong> Modalidad:</strong>
                                                {{grupo.periodos_escolares.modalidades.nombre}}
                                                <span> Grupo: {{grupo.clave}}</span>
                                                <span> Nivel: {{grupo.nivel}} {{grupo.identificador}}</span>

                                            </p>
                                        </div>
                                    </div>
                                    <div class="level-right" style="margin-right: 35px;">

                                        <div class="content" *ngIf="ctrl.dato.controls.grupos.length > 0">
                                            <span class="subtitle has-text-primary">
                                                <i class="fa fa-info-circle is-size-4 has-text-grey-light"> </i>
                                                Verifique que las matrículas que asigne sean correctas
                                            </span>
                                        </div>

                                    </div>
                                </nav>

                                <div class="content" style="overflow-y:auto;height: 58vh;">

                                    <table class="table is-striped is-fullwidth" style="width:100% !important;">
                                        <thead>
                                            <tr>
                                                <th><abbr>ID</abbr></th>
                                                <th>Alumno</th>
                                                <th>Matrícula</th>
                                                <th>Folio Certificado</th>
                                            </tr>
                                        </thead>
                                        <tbody formArrayName="grupos">
                                            <tr *ngFor="let val of ctrl.dato.controls.grupos.controls; let i = index;"
                                                [formGroupName]="i">
                                                <td style="vertical-align: middle;">{{ i + 1 }}</td>
                                                <td style="vertical-align: middle;"><strong>{{ val.value.matricula
                                                        }}</strong> {{ val.value.nombre }} </td>
                                                <td style="vertical-align: middle;">
                                                    <p class="control is-expanded  has-icon has-icon-right">
                                                        <input class="input" type="text" placeholder="Matrícula"
                                                            formControlName="matricula">
                                                    </p>
                                                </td>
                                                <td style="vertical-align: middle;">
                                                    <p class="control is-expanded  has-icon has-icon-right">
                                                        <input class="input" type="text" placeholder="Folio Certificado"
                                                            formControlName="folio_certificado">
                                                    </p>
                                                </td>

                                            </tr>
                                            <tr *ngIf="ctrl.dato.controls.grupos.length == 0">
                                                <td colspan="3" style="vertical-align: middle; color:#888;">Sin alumnos
                                                    en el grupo.</td>
                                            </tr>
                                        </tbody>

                                    </table>

                                </div>
                            </div>
                        </article>
                    </div>

                </section>
            </form>
        </div>
    </div>
</div>